var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { transparentize } from "polished";
import { forwardRef } from "react";
import { colors } from "../theme";
export const TextField = forwardRef(function TextField(_a, ref) {
    var { autoFocus = false, placeholder, defaultValue, onBlur, inputBorderColor } = _a, props = __rest(_a, ["autoFocus", "placeholder", "defaultValue", "onBlur", "inputBorderColor"]);
    return (_jsx(InputContainer, { children: _jsx(InputText, Object.assign({ defaultValue: defaultValue, autoFocus: autoFocus, placeholder: placeholder, ref: ref, type: "text", onBlur: onBlur, inputBorderColor: inputBorderColor }, props), void 0) }, void 0));
});
const InputText = styled.input(({ inputBorderColor }) => ({
    background: "none",
    border: 0,
    borderBottom: `solid 1px ${inputBorderColor}`,
    color: colors.greyMedium,
    font: "inherit",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    paddingTop: "1.2rem",
    width: "100%",
    "&::placeholder": {
        color: colors.greyMain,
    },
    "&:focus": {
        outline: "none",
        borderBottom: `solid 2px ${inputBorderColor}`,
    },
    "&:focus:hover": {
        borderBottom: `solid 2px ${transparentize(0.6, inputBorderColor)}`,
    },
    "&:hover": {
        borderBottom: `solid 2px ${transparentize(0.6, inputBorderColor)}`,
    },
}));
const InputContainer = styled.div(() => ({
    width: "100%",
    height: "4.4rem",
}));
//# sourceMappingURL=TextField.js.map